import { Typography, Stack } from "@mui/material";

export function Header({pageName}) {
  return (
    <div>
      <Stack direction="row" spacing={1} style={{borderBottomWidth:2, borderBottomStyle:"solid", borderColor:"#dddfe2", paddingBottom:5}}>
        {/* <Logo style={{height:60}}/> */}
        {/* <InsertChartRoundedIcon style={{paddingTop:6, fontSize:55, color:"navy"}} /> */}
        <Typography variant="h5" style={{paddingTop:7, paddingLeft:5, fontWeight:"bold", fontFamily:"Trade Gothic Next LT Pro Cn, sans-serif", fontSize:40}}>{pageName}</Typography>
      </Stack>
    </div>
  );
}